import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { setSecureCookie } from '../../utils/cookies';

const MyContext = createContext();

function CreditsContextProvider({ children }) {
    // Initialize state from cookies or default to null if not present
    const [credits, setCredits] = useState(() => {
        const savedCredits = Cookies.get('credits');
        return savedCredits !== undefined ? JSON.parse(savedCredits) : null;
    });

    // Update cookies whenever 'credits' changes
    useEffect(() => {
        setSecureCookie('credits', JSON.stringify(credits), { maxAge: 7 * 24 * 60 * 60 }); // Expires in 7 days
    }, [credits]);

    const contextValue = useMemo(() => ({
        credits,
        setCredits
    }), [credits, setCredits]);

    return (
        <MyContext.Provider value={contextValue}>
            {children}
        </MyContext.Provider>
    )
}

export function useMyContext() {
    return useContext(MyContext);
}

export default CreditsContextProvider;
